<template>
  <button
    class="button-toggle"
    :data-off="!isFastInterpretation"
    @click="sendFastIntepretation"
  >
    <ToggleSwitch
      :modelValue="isFastInterpretation"
      @update:modelValue="sendFastIntepretation"
    />
    <div>
      {{ $t('live_sound') }} <br>
      <span class="smaller dim">
    {{ $t('live_sound_comment_1') }}
  </span>    </div>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { storeToRefs } from 'pinia';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { useSocketStore } from '@/stores/socket';
import { useToastStore } from '@/stores/toast';


const { t } = useI18n();
const toastStore = useToastStore();
const socketStore = useSocketStore();
const { isFastInterpretation } = storeToRefs(socketStore);

const sendFastIntepretation = () => {
  isFastInterpretation.value = !isFastInterpretation.value;
  socketStore.sendMessageFi(isFastInterpretation.value);
  if (isFastInterpretation.value) {
    toastStore.info(t('toast_fi_on'), 'FI');
  } else {
    toastStore.info(t('toast_fi_off'), 'FI');
  }
};
</script>

<style scoped lang="scss"></style>
